/**
 * Javascript for handling 3rd party scripts
 */

(function ($) {
  var JhThirdPartyHandler = { 

    init: function () {
      JhThirdPartyHandler.freshChat();
    },    

    // Fresh chat initialization 
    freshChat: function () {
      // check the fresh chat status
      if ( jh_fresh_chat.settings.status !== false ) {
        window.fcWidget.init({
          "config": {
            "agent": {
               "hideBio": true,
               "hidePic": true
            },
            "disableNotifications": true,
            "faqPopupView": true,       
            "hideFileUpload": true
          },
          "host": jh_fresh_chat.host,
          "token": jh_fresh_chat.token, 
        });
      }
    },

  };

  $( document ).ready(
    function () {
      JhThirdPartyHandler.init();
    }
  );

})( jQuery );